module.exports = __webpack_public_path__ + "static/media/hakusteel-logo.9c2c600d.png";